/**
 * @author: wayou
 * @description: 原 src/common/components/loadAvatar.js
 */

import React, { SyntheticEvent } from 'react';
import { IUserMedal } from '@umu/umu-types';
import { components } from 'common';
const { If, PreImg } = components;
import * as imageUtil from '@umu/umu-image-handle';
import UserLevelBadge, { TUserLevelSize } from '../user/userLevelBadge/userLevelBadge';
import UserMedalIcon from '../user/userMedalIcon/userMedalIcon';
import { getAvatarWord } from './loadAvatarUtil';
import './loadAvatar.scss';

import defaultAvatar from './images/weike_avatar_default.png';
const MAX_RETRY_COUNT_ON_ERROR = 3; // 最多加载次数

interface IProps {
    className?: string;
    defaultAvatar?: string;
    avatar: string;
    avatarName?: string;
    index: number;

    userLevelInfo?: number;
    userMedalInfo?: IUserMedal;
    showUserLevel?: number;
    userMedalWidth?: 20 | 30 | 16 | 12;
    userLevelSize?: TUserLevelSize;

    src?: string;
    link?: string;
}

function loadError(e: SyntheticEvent<HTMLImageElement, Event>) {
    const el = e.currentTarget as HTMLImageElement;
    el.setAttribute('src', defaultAvatar);
    const parentEl = el.parentElement as HTMLDivElement;
    const className = parentEl.getAttribute('class') || '';
    parentEl.setAttribute('class', className + ' useDefault');
}

function onClick(link?: string) {
    if (link) {
        window.location.href = link;
    }
}

export { getAvatarWord };

export function LoadAvatar({
    index,
    avatar,
    className,
    avatarName,
    link,
    userLevelInfo,
    userMedalInfo,
    userMedalWidth,
    userLevelSize,
    showUserLevel,
}: IProps) {
    let retryCountOnError = 0; // 默认图片加载失败次数
    const onLoadError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
        // 避免重复加载
        if (retryCountOnError > MAX_RETRY_COUNT_ON_ERROR) {
            return;
        }
        loadError(e);
        retryCountOnError++;
    };

    let _avatar = avatar;

    const indexClass = typeof index !== 'undefined' ? ' imgAvat_' + ((index % 9) + 1) : '';
    const useDefaultClass = avatar ? '' : ' useDefault';

    const word = getAvatarWord(avatarName);
    const avatarStyle: Record<string, any> = {};
    if (link) {
        avatarStyle.cursor = 'pointer';
    }
    // 兼容w_没有拼的地方
    if (_avatar && /w_$/.test(_avatar)) {
        _avatar = imageUtil.appendWidth(_avatar, 90);
    }

    let userLevelHolderSize = userLevelSize as string;
    userLevelHolderSize = userLevelHolderSize ? ' size-' + userLevelHolderSize : '';

    return (
        <div className={'load-user-avatar-info ' + className}>
            <div
                style={avatarStyle}
                className={'img imgAvat ' + indexClass + useDefaultClass}
                onClick={() => {
                    onClick(link);
                }}
            >
                <If condition={!word}>
                    <PreImg>
                        <img src={_avatar || defaultAvatar} onError={onLoadError} alt="" className="loaded" />
                    </PreImg>
                </If>
                <If condition={!!word}>
                    <div className="avatarWord">
                        <div className="word">{word}</div>
                    </div>
                </If>
            </div>
            <If condition={!!showUserLevel && !!userLevelInfo}>
                <div className={'user-level-info-holder' + userLevelHolderSize}>
                    <UserLevelBadge userLevelInfo={userLevelInfo!} userLevelSize={userLevelSize} />
                </div>
            </If>
            <If condition={!!showUserLevel && !!userMedalInfo && !!userMedalInfo.medal_type}>
                <div className="user-medal-info-holder">
                    <UserMedalIcon userMedalInfo={userMedalInfo!} userMedalWidth={userMedalWidth || 30} />
                </div>
            </If>
        </div>
    );
}
